import React, { useCallback, useState } from "react";
import {
  Button,
  DetailDrawer,
  InnoTable,
  Popover,
  TableList,
} from "InnoUI/components";
import SC from "./style";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import theme from "@theme";
import { requestTypeForUpdate } from "utils/optionData/utils";
import JournalDetails from "views/ProjectHome/Journal/JournalDetails";
import TimezoneConverter from "components/TimeZoneConvertor";
import { formatAlarmDateTime } from "utils/helper";
import PointIdIndicatorInJournal from "components/PointIdIndicatorInJournal";

const ActiveJournals = (props) => {
  const {
    popupState,
    data,
    pageSize,
    currentPage,
    setCurrentPage = () => {},
    setPageSize = () => {},
    isLoading = false,
    chatUI = false,
  } = props;
  // const [data, setData] = useState(data);
  const [record, setTotalRecord] = useState();
  const [selectedTab, setSelectedTab] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const occupantId = searchParams.get("projectId");
  const folderId = searchParams.get("folderId");
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState();

  const [filters, setFilters] = useState({
    requestType: null,
    searchValue: null,
    propertyIds: null,
    roles: null,
  });

  const handlePagination = (page, pageSize) => {
    setPageSize(pageSize);
    setCurrentPage(page);
  };

  const onRowClick = useCallback(() => {}, []);

  const onAddDataCallback = () => {
    navigate(`/journal/add-journal?projectId=${occupantId}&type=${type}`);
  };

  const handleUpdate = (record) => {
    navigate(
      `/journal/update-journal?projectId=${occupantId}&type=${type}&journalId=${record.id}`,
    );
  };

  const handleJournalClick = (record) => {
    setSelectedRow(record.id);
    setOpen(true);
  };

  const closeDrawer = () => {
    setOpen(false);
  };

  const handleThread = (record) => {
    navigate(
      `/journal/open-thread?projectId=${occupantId}&folderId=${folderId}&type=${type}&journalId=${record.id}`,
    );
  };

  const journalColumn = [
    {
      title: "Ingested",
      width: 50,
      dataIndex: "pointId",
      render(value, record) {
        return record.pointId ? <PointIdIndicatorInJournal /> : "--";
      },
    },
    {
      title: "Journal Subject",
      width: 350,
      dataIndex: "subject",
      fixed: "left",
      render(value, record) {
        const menuItems = [
          {
            id: 1,
            text: "Open Thread",
            onClick: (e) => {
              e.stopPropagation();
              handleThread(record);
            },
          },
          {
            id: 2,
            text: "Update",
            onClick: (e) => {
              e.stopPropagation();
              handleUpdate(record);
            },
          },
        ];
        return (
          <SC.PopoverContainer>
            {value}
            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <SC.PopoverSpan>
                    <SC.MoreVertIcon />
                  </SC.PopoverSpan>
                ),
              }}
              popoverContent={
                <TableList
                  sx={{
                    borderBottom: `1px solid rgba(227, 110, 0, 0.1)`,
                  }}
                  items={menuItems || []}
                  popupState={popupState}
                />
              }
            />
          </SC.PopoverContainer>
        );
      },
    },
    {
      title: "Request Type",
      dataIndex: "requestType",
      width: 150,

      render(value, record) {
        const request = requestTypeForUpdate.find((item) => item.id === value);
        return (
          <p
            style={{
              color: theme.colors.modernGray[700],
              fontWeight: 500,
              margin: 0,
            }}
          >
            {request ? request.label : "Unknown"}
          </p>
        );
      },
    },
    {
      title: "Request To",
      width: 150,
      dataIndex: "roles",
      render(value, record) {
        return (
          <Popover
            sx={{
              cursor: "pointer",
            }}
            buttonLabel={{
              icon: (
                <p
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "150px",
                    color: theme.colors.modernGray[600],
                    fontWeight: 500,
                    margin: 0,
                  }}
                >
                  {value}
                </p>
              ),
            }}
            popoverContent={
              <table style={{ width: "200px" }}>
                <thead>
                  <tr>
                    <th
                      style={{
                        background:
                          "linear-gradient(135deg, #E36E00 0%, #FFAE00 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        borderBottom: `1px solid rgba(227, 110, 0, 0.2)`,
                        textAlign: "left",
                        fontWeight: 600,
                        padding: "12px",
                      }}
                    >
                      Roles
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ marginBottom: "20px" }}>
                    <td
                      style={{
                        borderBottom: `1px solid rgba(227, 110, 0, 0.1)`,
                        padding: "12px",
                        color: theme.colors.modernGray[600],
                      }}
                    >
                      {value || "N/A"}
                    </td>
                  </tr>
                </tbody>
              </table>
            }
          />
        );
      },
      // ...roleFilter,
    },
    {
      title: "To",
      width: 250,
      dataIndex: "sendTo",
      render(value, record) {
        return (
          <Popover
            sx={{
              cursor: "pointer",
            }}
            buttonLabel={{
              icon: (
                <p
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "150px",
                    color: theme.colors.modernGray[600],
                    fontWeight: 500,
                    margin: 0,
                  }}
                >
                  {value}
                </p>
              ),
            }}
            popoverContent={
              <table style={{ width: "200px" }}>
                <thead>
                  <tr>
                    <th
                      style={{
                        background:
                          "linear-gradient(135deg, #E36E00 0%, #FFAE00 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                        borderBottom: `1px solid rgba(227, 110, 0, 0.2)`,
                        textAlign: "left",
                        fontWeight: 600,
                        padding: "12px",
                      }}
                    >
                      Email
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ marginBottom: "20px" }}>
                    <td
                      style={{
                        borderBottom: `1px solid rgba(227, 110, 0, 0.1)`,
                        padding: "12px",
                        color: theme.colors.modernGray[600],
                      }}
                    >
                      {value || "N/A"}
                    </td>
                  </tr>
                </tbody>
              </table>
            }
          />
        );
      },
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      width: 300,

      render(value, record) {
        return (
          <span
            style={{
              color: theme.colors.modernGray[600],
              fontWeight: 500,
            }}
          >
            <TimezoneConverter time={value} />
          </span>
        );
      },
    },
    {
      title: "Property Name",
      dataIndex: "propertyName",
      width: 180,
      render(value, record) {
        return <p>{value}</p>;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render(value, record) {
        return (
          <span
            style={{
              color:
                value === 1
                  ? theme.colors.modernSuccess
                  : theme.colors.modernError,
              fontWeight: 600,
              padding: "4px 12px",
              background:
                value === 1
                  ? "rgba(16, 185, 129, 0.1)"
                  : "rgba(239, 68, 68, 0.1)",
              borderRadius: theme.modernTokens.borderRadius.full,
              border:
                value === 1
                  ? "1px solid rgba(16, 185, 129, 0.2)"
                  : "1px solid rgba(239, 68, 68, 0.2)",
              fontSize: "12px",
            }}
          >
            {value === 1 ? "Active" : "Closed"}
          </span>
        );
      },
    },
    {
      title: "Alarm set for",
      width: 300,
      render(value, record) {
        const alarmData = record?.alarmData || [];
        const primaryAlarms = alarmData.filter(
          (alarm) => alarm.alarmType === 0,
        );
        if (!primaryAlarms.length) return <p>-</p>;
        const { alarmDate, alarmTime } = primaryAlarms[0];
        return <p>{formatAlarmDateTime(alarmDate, alarmTime)}</p>;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      fixed: "right",
      width: 50,
      render(value, record) {
        return (
          <Button
            caption={"View"}
            onClick={() => handleJournalClick(record)}
            color="white"
            fontSize="12px"
            style={{
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "50px",
              height: "28px",
              borderRadius: theme.modernTokens.borderRadius.md,
              textTransform: "normal",
              fontWeight: 600,
              border: "none",
              boxShadow: theme.modernTokens.shadows.sm,
              transition: theme.modernTokens.transitions.normal,
            }}
          />
        );
      },
    },
  ];
  const interactiveJournalColumn = [
    {
      title: "Journal Subject",
      width: 350,
      dataIndex: "subject",
      fixed: "left",
      render(value, record) {
        const menuItems = [
          {
            id: 1,
            text: "Open Thread",
            onClick: (e) => {
              e.stopPropagation();
              handleThread(record);
            },
          },
          {
            id: 2,
            text: "Update",
            onClick: (e) => {
              e.stopPropagation();
              handleUpdate(record);
            },
          },
        ];
        return (
          <SC.PopoverContainer>
            {value}
            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <SC.PopoverSpan>
                    <SC.MoreVertIcon />
                  </SC.PopoverSpan>
                ),
              }}
              popoverContent={
                <TableList
                  sx={{
                    borderBottom: `1px solid rgba(227, 110, 0, 0.1)`,
                  }}
                  items={menuItems || []}
                  popupState={popupState}
                />
              }
            />
          </SC.PopoverContainer>
        );
      },
    },
    {
      title: "Request Type",
      dataIndex: "requestType",
      width: 150,

      render(value, record) {
        const request = requestTypeForUpdate.find((item) => item.id === value);
        return (
          <p
            style={{
              color: theme.colors.modernGray[700],
              fontWeight: 500,
              margin: 0,
            }}
          >
            {request ? request.label : "Unknown"}
          </p>
        );
      },
    },

    {
      title: "Property Name",
      dataIndex: "propertyName",
      width: 180,
      render(value, record) {
        return <p>{value}</p>;
      },
    },

    {
      title: "Action",
      dataIndex: "action",
      fixed: "right",
      width: 50,
      render(value, record) {
        return (
          <Button
            caption={"View"}
            onClick={() => handleJournalClick(record)}
            color="white"
            fontSize="12px"
            style={{
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "50px",
              height: "28px",
              borderRadius: theme.modernTokens.borderRadius.md,
              textTransform: "normal",
              fontWeight: 600,
              border: "none",
              boxShadow: theme.modernTokens.shadows.sm,
              transition: theme.modernTokens.transitions.normal,
            }}
          />
        );
      },
    },
  ];

  const onFilterChange = (data) => {
    const { requestType, propertyName, roles } = data;
    setFilters({
      ...filters,
      requestType: requestType,
      propertyIds: propertyName,
      roles: roles,
    });
  };

  const tableConfig = {
    sno: true,
    draggable: false,
    selection: false,
    expandable: false,
    pagination: {
      position: ["topRight", "bottomRight"],
      current: currentPage,
      defaultCurrent: currentPage,
      pageSize: pageSize,
      total: data?.totalCount || 0,
      onChange: (page, pageSize) => {
        handlePagination(page, pageSize);
      },
      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
      itemRender: (_, type, originalElement) => {
        if (type === "prev") {
          return <a>Previous</a>;
        }
        if (type === "next") {
          return <a>Next</a>;
        }
        return originalElement;
      },
    },
    addNew: false,
    search: false,
    action: false,
    divBorder: false,
  };

  return (
    <div style={{ marginBottom: "24px" }}>
      <SC.CardContainerStyle>
        <InnoTable
          tableConfig={tableConfig}
          loading={isLoading}
          padding="16px"
          column={chatUI ? interactiveJournalColumn : journalColumn}
          data={data?.data || []}
          searchKeys={["subject", "roles", "sendTo"]}
          selectedItems={[]}
          onAddDataCallback={onAddDataCallback}
          onFilterChange={onFilterChange}
          onRowClick={onRowClick}
        />
      </SC.CardContainerStyle>

      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          closable={true}
          width={"865px"}
          children={
            <JournalDetails
              onClose={closeDrawer}
              selectedRowId={selectedRow}
              fetchData={""}
            />
          }
        ></DetailDrawer>
      )}
    </div>
  );
};

export default ActiveJournals;
